import React from 'react';
import { Helmet } from 'react-helmet';

import './index.scss';
import { AsyncCss } from '../components/async-css';

export default class Layout extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render = () => (
    <>
      <Helmet>
        <title>Wordy</title>
        <meta name="description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <link rel="icon" type="image/png" href="/favicon.png" />
      </Helmet>
      <AsyncCss url="//fast.fonts.net/cssapi/a0868e3f-017b-4a10-a1da-948519c00b62.css" />
      <main>{ this.props.children }</main>
    </>
  )
}